import { formatPrice } from '../../lib/format';
import type { StructuralZone } from '../../types/market';
import { Badge } from '../ui/Badge';
import { Panel } from '../ui/Panel';

export function SupportResistancePanel({ zones }: { zones: StructuralZone[] }): React.JSX.Element {
  return (
    <Panel
      title="Support and resistance scenarios"
      description="Dynamic zones combine swing reactions, adaptive history, impulse origins, recency, and volume. They are possible reaction areas, not guaranteed floors or ceilings."
    >
      <div className="zone-list">
        {zones.length === 0 ? (
          <p className="panel-description">No sufficiently strong nearby zones were detected.</p>
        ) : (
          zones.map((zone) => (
            <article className="zone-card" key={zone.id}>
              <div className="zone-card-header">
                <div>
                  <strong>{zone.kind === 'support' ? 'Support' : 'Resistance'} ${formatPrice(zone.low)}–${formatPrice(zone.high)}</strong>
                  <p>{Math.abs(zone.distancePercent).toFixed(2)}% away · {zone.touches} reactions · {zone.ageCandles} candles old</p>
                </div>
                <Badge tone={zone.kind === 'support' ? 'positive' : 'negative'}>{zone.strength}/100</Badge>
              </div>
              <p>{zone.description}</p>
              <p>{zone.source.join(' · ')}</p>
            </article>
          ))
        )}
      </div>
    </Panel>
  );
}
